import React from 'react';
import { FaGithub, FaInstagram, FaEnvelope, FaLinkedin, FaGamepad } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';

const SOCIAL_LINKS = [
  {
    name: 'GitHub',
    href: 'https://github.com/NakhalanAtqiyaAP',
    icon: FaGithub,
    hoverBg: 'hover:bg-blue-600',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/orangejahad/',
    icon: FaInstagram,
    hoverBg: 'hover:bg-pink-600',
  },
  {
    name: 'Email',
    href: 'mailto:nakhalanatqiyaarifin@gmail.com',
    icon: FaEnvelope,
    hoverBg: 'hover:bg-red-600',
    isExternal: false,
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/nakhalan-atqiya-arifin-putra-4b5b082a3/',
    icon: FaLinkedin,
    hoverBg: 'hover:bg-blue-700',
  },
];

const Footer = () => {
  const { isDark } = useTheme();
  const currentYear = new Date().getFullYear();

  const footerBg = isDark
    ? 'bg-[#060B14] border-[#1E3A5F]'
    : 'bg-gray-900 border-gray-800';
  const socialItemBg = isDark ? 'bg-[#0D1520]' : 'bg-gray-800';
  const dividerColor = isDark ? 'border-[#1E3A5F]' : 'border-gray-800/80';
  const mutedText = isDark ? 'text-slate-500' : 'text-gray-400';
  const mutedText2 = isDark ? 'text-slate-600' : 'text-gray-500';

  return (
    <footer className={`${footerBg} text-white py-8 md:py-12 px-4 border-t`}>
      <div className="container mx-auto max-w-5xl">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6 md:mb-8">
          {/* Brand & Tagline */}
          <div className="flex flex-col md:flex-row items-center text-center md:text-left gap-3">
            <div className="w-10 h-10 bg-blue-600 pixel-border flex items-center justify-center shrink-0">
              <FaGamepad className="text-white text-base" />
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-bold pixel-font tracking-wide">Nakhalan Atqiya</h3>
              <p className={`${mutedText} text-xs md:text-sm max-w-md`}>
                Live to be useful to others, the environment and the universe
              </p>
            </div>
          </div>
          
          {/* Social Links */}
          <nav aria-label="Social Media Links">
            <ul className="flex space-x-3 md:space-x-4">
              {SOCIAL_LINKS.map(({ name, href, icon: Icon, hoverBg, isExternal = true }) => (
                <li key={name}>
                  <a
                    href={href}
                    target={isExternal ? '_blank' : undefined}
                    rel={isExternal ? 'noopener noreferrer' : undefined}
                    aria-label={name}
                    className={`w-9 h-9 md:w-10 md:h-10 ${socialItemBg} flex items-center justify-center transition-all duration-200 transform hover:-translate-y-1 ${hoverBg} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <Icon className="text-sm md:text-base" />
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        
        {/* Copyright */}
        <div className={`border-t ${dividerColor} pt-6 text-center`}>
          <p className={`${mutedText} text-xs md:text-sm`}>
            © {currentYear} Nakhalan Atqiya Arifin Putra. All rights reserved.
          </p>
          <p className={`${mutedText2} text-xs mt-1 italic`}>Live here in the moment</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
